import type { ReactNode } from 'react';

import { useSuspenseQuery } from '@apollo/client/react';

import { GET_APP_SETTINGS } from '#src/graphql/queries/app-settings';
import { GET_REACTIONS } from '#src/graphql/queries/reactions';
import { AppSettingsProvider } from '#src/providers/app-settings-provider';
import { ReactionsProvider } from '#src/providers/reactions-provider';

interface AppCacheBootstrapProps {
  children: ReactNode;
}

/**
 * Runs cache-and-network GraphQL queries under Suspense, then provides app settings
 * and reaction catalog to the tree.
 */
export function AppCacheBootstrap({ children }: AppCacheBootstrapProps) {
  const { data: appSettingsData } = useSuspenseQuery(GET_APP_SETTINGS, {
    fetchPolicy: 'cache-and-network',
  });
  const { data: reactionsData } = useSuspenseQuery(GET_REACTIONS, {
    // With persisted cache, cache-first never refetches a “complete” catalog snapshot.
    fetchPolicy: 'cache-and-network',
  });

  return (
    <AppSettingsProvider value={appSettingsData.appSettings}>
      <ReactionsProvider value={reactionsData.reactions}>
        {children}
      </ReactionsProvider>
    </AppSettingsProvider>
  );
}
